import React from 'react'
import styled from 'styled-components'
import { useLastTruthy } from '../../hooks/useLast'
import { AdvancedSwapDetails, AdvancedSwapDetailsProps } from './AdvancedSwapDetails'
import { isMobile } from 'react-device-detect'

const AdvancedDetailsFooter = styled.div<{ show: boolean }>`
  position: absolute;
  left: ${isMobile ? '0' : '45px'};
  padding-top: calc(16px + 2rem);
  padding-bottom: 20px;
  margin-top: -1rem;
  width: 100%;
  max-width: 400px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  color: ${({ theme }) => theme.text2};
  background: #171717;
  box-shadow: 0px 0px 50px 0px #000000;
  z-index: ${({ show }) => (show && isMobile ? '2' : '-1')};

  transform: ${({ show }) => (show ? 'translateY(0%)' : 'translateY(-100%)')};
  transition: transform 300ms ease-in-out;
`

export default function AdvancedSwapDetailsDropdown({ trade, ...rest }: AdvancedSwapDetailsProps) {
  const lastTrade = useLastTruthy(trade)

  return (
    <AdvancedDetailsFooter show={Boolean(trade)}>
      <AdvancedSwapDetails {...rest} trade={trade ?? lastTrade ?? undefined} />
    </AdvancedDetailsFooter>
  )
}
